var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectangle1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.499512,
    width: 36,
    height: 36,
    fill: "url(#pattern0_249_3867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_249_3867",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_249_3867",
    transform: "scale(0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_249_3867",
    width: 36,
    height: 36,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAACbUlEQVR4Ac3BTUgUUQDA8f978zaXkKWgstpLQhS6QZcOHRQpN3DIg8QGFURB16DCDiLrrW4diq7RdQkEL8EK7UqXQEgoiDFTwQ4eDNRE8SNn5r0mG0rEbNbP+f0EazTbzl2tuQOcARSVmZGSq+VipsQmKVa50OI80Zp2Nu+AxGoASmySInTJ/nzS0/oev41LIcpUSpgJY8xTtkAR8ow5BygCQoib5d76t+wByR8mSUgivrJHJDGjqMDFlsEWCxo8SBOVwBKGH0KYV+VipsR/KCJoaxtTc4sLPdqYVo8KGTCAMdzO2s71UjHTzQYkEcwuLeQ1tLI1ytcUsraTYwOKCAxcI1BzdB8P2k+QSimi6OocYWrK5fChBNPfPXzfKF9TyNoOpWKmm3VIojCcJlBbu59USlGp9PF95DvSWJYgoHxNIWs7OdYh2SVNjSnyHWksSxBQvqaQtZ0ca0h2UVNjinxHGssSBJSvKWRtJ8cqkl3W1Jgi35HGsgQB5WsKzbZznpBiFwwOLXDj1girJasE8wuGgNKGs0A/AcUOqqqS/LK8bJj45vJPhoOEFDvoSq6GvvI0nmtYy3U1Y2OLrJBMElLsoPpMNfWZatYzNeXS1TnCCoNHSBIzkpiRxIwkZiQxI4kZScxIYkYRSqpE/5LrTgiBU51MjrNHFKHi61NDwDH2mCRmJDEjiRlJzEiimSHguprtMjvr8ZdYIqSIQCDeGczljx/mePlinERCslXDX+YJeUqIAUKKCKoS6uGS6zb5vqkeeD/LthI8e1OsGyVkEcHo8PPJurr7Pb42tcARIMnWeAg+Scnjvt7MI1b5CfEkzPRNZ1C2AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle1);
export default __webpack_public_path__ + "static/media/Rectangle 1.070bdfea0334213c44a650945cc91fe8.svg";
export { ForwardRef as ReactComponent };